import { axiosClient } from "@/shared/api/axios-client";
import type { CargarCFDIResultado } from "@/lib/types";

/**
 * Endpoint de carga de CFDI · `multipart/form-data`. Devuelve la
 * solicitud actualizada + flag de reglasAutorizadas + lista de errores
 * de reglas (vacía si reglasAutorizadas=true).
 */
export const cargarCfdiApi = {
  /**
   * Gestión Documental (D-2) · el PDF viaja junto con el XML: el servidor registra ambos en el
   * expediente al pasar las reglas (ya no los sube el navegador tras validar con el SAT).
   */
  cargar: (solicitudId: string, xml: File, pdf?: File | null) => {
    const form = new FormData();
    form.append("cfdi", xml);
    if (pdf) form.append("pdf", pdf);
    return axiosClient
      .post<CargarCFDIResultado>(`/api/solicitudes/${solicitudId}/cfdi`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
